import React from 'react';
import {motion} from 'framer-motion';
import {useLanguage} from '../contexts/LanguageContext';
import * as FiIcons from 'react-icons/fi';
import {FaInstagram, FaFacebook, FaThreads} from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';
import ShareButtons from './ShareButtons';

const {FiHeart, FiCode} = FiIcons;

const PRIVACY_LABELS = {
  zh: '隱私政策',
  en: 'Privacy Policy',
  ja: 'プライバシーポリシー',
  es: 'Política de Privacidad',
};

const SOCIAL_LINKS = [
  {
    href: 'https://www.threads.com/@homy.hk',
    icon: FaThreads,
    label: 'Threads',
    color: 'hover:text-gray-900',
  },
  {
    href: 'https://www.instagram.com/homy.hk',
    icon: FaInstagram,
    label: 'Instagram',
    color: 'hover:text-pink-600',
  },
  {
    href: 'https://www.facebook.com/profile.php?id=61578745554661',
    icon: FaFacebook,
    label: 'Facebook',
    color: 'hover:text-blue-600',
  },
];

const DeveloperFooter = () => {
  const {t, currentLang} = useLanguage();
  const currentYear = new Date().getFullYear();
  const privacyLabel = PRIVACY_LABELS[currentLang] || PRIVACY_LABELS.en;

  return (
    <motion.div
      className="bg-white rounded-xl p-4 mt-4 border border-gray-200 shadow-sm"
      initial={{opacity: 0, y: 20}}
      animate={{opacity: 1, y: 0}}
      transition={{delay: 0.7}}
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        {/* 開發者信息 */}
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <motion.div
            className="flex items-center gap-2"
            whileHover={{scale: 1.05}}
            transition={{type: 'spring', stiffness: 300}}
          >
            <SafeIcon icon={FiCode} className="w-4 h-4 text-gray-500" />
            <span>{t('developedWith')}</span>
            <motion.div
              animate={{scale: [1, 1.2, 1]}}
              transition={{duration: 1.5, repeat: Infinity, repeatType: 'reverse', ease: 'easeInOut'}}
            >
              <SafeIcon icon={FiHeart} className="w-4 h-4 text-red-500" />
            </motion.div>
            <span>{t('by')}</span>
          </motion.div>
          <motion.a
            href="https://homy.hk"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-slate-700 hover:text-purple-600 transition-colors duration-300"
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
          >
            Homy Tech Limited
          </motion.a>
        </div>

        {/* 分享按鈕 */}
        <ShareButtons />
      </div>

      {/* 社交媒體連結 */}
      <motion.div
        className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-center gap-4"
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        transition={{delay: 0.9}}
      >
        {SOCIAL_LINKS.map((social) => (
          <motion.a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
            className={`text-gray-400 ${social.color} transition-colors duration-200`}
            whileHover={{scale: 1.15}}
            whileTap={{scale: 0.95}}
          >
            <social.icon className="w-5 h-5" />
          </motion.a>
        ))}
      </motion.div>

      {/* 底部連結 */}
      <motion.div
        className="mt-3 pt-3 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-2"
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        transition={{delay: 1}}
      >
        <p className="text-xs text-gray-500">
          © {currentYear} Convert Master
        </p>
        <a
          href="/#/privacy"
          className="text-xs text-gray-400 hover:text-purple-600 transition-colors"
        >
          {privacyLabel}
        </a>
      </motion.div>
    </motion.div>
  );
};

export default DeveloperFooter;